import { render, staticRenderFns } from "./AttendanceStatusChip.vue?vue&type=template&id=4a251851"
import script from "./AttendanceStatusChip.vue?vue&type=script&lang=js"
export * from "./AttendanceStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports